import React from 'react';

import { ZonedDate } from '@eika-infrastruktur/date';
import { Label } from '@eika/label';

import { Notification, NotificationSelectedData, Language } from '../types';
import { convertDateToText, getTimezoneDifferentMessage } from '../utils';

export interface CalendarNotificationProps {
    timeZoneDifferent: boolean;
    notification?: Notification;
    selected?: ZonedDate;
    language?: Language;
}

const findNotificationBasedOnSelectedDate = (
    notification?: Notification,
    selectedDate?: ZonedDate,
): NotificationSelectedData | undefined => {
    if (!notification || !notification.selectedDate || !selectedDate) {
        return undefined;
    }
    return notification.selectedDate?.find((note) => {
        const selectedList = convertDateToText(selectedDate).split('.');
        const dateList = `${note.id}`.split('.');

        if (!dateList[2]) {
            selectedList.pop();
        }
        if (!dateList[1]) {
            selectedList.pop();
        }

        return dateList.join('.') === selectedList.join('.');
    });
};

const findNotificationBasedOnWeekday = (
    notification?: Notification,
    selectedDate?: ZonedDate,
): NotificationSelectedData | undefined => {
    if (!notification || !notification.selectedDate || !selectedDate) {
        return undefined;
    }
    return notification.selectedDay?.find((note) => note.id === `${selectedDate.getDay()}`);
};

const CalendarNotification = ({
    notification,
    selected,
    timeZoneDifferent,
    language,
}: CalendarNotificationProps): JSX.Element | null => {
    if (!selected && !timeZoneDifferent) {
        return null;
    }

    const weekDayNotification = findNotificationBasedOnWeekday(notification, selected);
    const selectedDayNotification = findNotificationBasedOnSelectedDate(notification, selected);
    const list: NotificationSelectedData[] = [];

    if (weekDayNotification) {
        list.push(weekDayNotification);
    } else if (selectedDayNotification) {
        list.push(selectedDayNotification);
    }

    if (timeZoneDifferent) {
        list.push({
            id: 'sgw-calendar-is-time-zone-different-message',
            text: notification?.timezoneDifferentMessage ?? getTimezoneDifferentMessage(language),
        });
    }

    return list.length ? (
        <div aria-live="polite" className="sgw-calendar__notification-wrapper">
            {list.map((note) => (note ? <Label key={`calendar-note-${note.id}`} text={note.text} /> : null))}
        </div>
    ) : null;
};

export default CalendarNotification;
